import {ThemeOptions} from '@mui/material';
import {merge} from 'lodash';
import {themePoppins} from './themePoppins';

export const themePoppinsAero = merge({}, themePoppins, {
   palette: {
      mode: 'light',
      primary: {main: '#0055a5'},
      secondary: {main: '#3eabd1'},
      background: {
         default: '#f5f7fa',
         paper: 'rgba(255,255,255,0.8)',
      },
   },
   shape: {
      borderRadius: 8,
   },
   typography: {
      fontFamily: '"Poppins", "Roboto", sans-serif',
      h1: {fontWeight: 700},
      h2: {fontWeight: 600},
   },
   components: {
      MuiCssBaseline: {
         styleOverrides: {
            '.Panel-root': {
               transition:
                  'transform 400ms cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 400ms cubic-bezier(0.25, 0.8, 0.25, 1)',
               transform: 'translateY(0)', // start position
               boxShadow: '0px 1px 6px -3px rgba(0,0,0,0.15)',
            },

            '.Panel-root:has(:focus), .Panel-root:hover': {
               transform: 'translateY(-4px)', // ground easing
               boxShadow: '0px 6px 20px -4px rgba(89, 130, 212, 0.5)',
            },
         },
      },
      MuiPaper: {
         styleOverrides: {
            root: {
               backdropFilter: 'blur(12px)',
               backgroundImage: 'linear-gradient(145deg, #ffffffaa, #f5f5f5cc)',
            },
         },
      },
      MuiButton: {
         styleOverrides: {
            root: {
               borderRadius: 6,
               textTransform: 'none',
               fontWeight: 600,
               transition: 'all 0.25s ease',
               '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
               },
            },
         },
      },
   },
}) as ThemeOptions;
